__turbopack_context__.v({
  "className": "work_sans_4d360033-module__kru27W__className",
  "variable": "work_sans_4d360033-module__kru27W__variable",
});
